module.exports = __webpack_public_path__ + "img/79c5545.png";